import {
  ApplicationConfig,
  provideZoneChangeDetection,
  importProvidersFrom,
  inject,
  provideAppInitializer,
} from '@angular/core';
import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import { routes } from './app.routes';
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
} from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideClientHydration } from '@angular/platform-browser';

import { NgxPermissionsModule } from 'ngx-permissions';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { provideTransloco } from '@ngneat/transloco';
import { provideTranslocoLocale } from '@ngneat/transloco-locale';
import { TranslocoHttpLoader } from './shared/services/transloco-loader';
import { Languages } from './shared/services/translation.serive';
import { DatePipe, registerLocaleData } from '@angular/common';
import localeKa from '@angular/common/locales/ka';
import { TruncateLimit } from './shared/directives/truncate.directive';
import { errorInterceptor } from './shared/interceptors/error.interceptor';
import { NumberToDecimalPipe } from './shared/pipes/number-to-decimal.pipe';
import { turnstileInterceptor } from './shared/interceptors/http.interceptor';

function getStoredLang() {
  return localStorage.getItem('smsLang')
    ? (JSON.parse(localStorage.getItem('smsLang') ?? '') as Languages)
    : 'ka';
}

registerLocaleData(localeKa, 'ka');

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      }),
      withComponentInputBinding()
    ),
    // turnstileInterceptor
    provideHttpClient(withInterceptors([errorInterceptor])),
    //  provideAppInitializer(() => {
    //     const turnsTileService = inject(TurnsTileService);
    //     return appInitializer(turnsTileService);
    //   }),

    provideClientHydration(),
    provideAnimationsAsync(),
    importProvidersFrom(
      HttpClient,
      FormsModule,
      ReactiveFormsModule,
      // MaterialModule,
      NgxPermissionsModule.forRoot(),
      CalendarModule.forRoot({
        provide: DateAdapter,
        useFactory: adapterFactory,
      })
    ),
    { provide: TruncateLimit, useValue: 20 },

    provideTransloco({
      config: {
        availableLangs: ['ka', 'en'],
        defaultLang: getStoredLang(),
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        // prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    DatePipe,
    NumberToDecimalPipe,
    provideTranslocoLocale({
      langToLocaleMapping: {
        en: 'en-US',
        ka: 'ka-GE',
      },
    }),
  ],
};
// export function HttpLoaderFactory(http: HttpClient) {
//   return new TranslateHttpLoader(http);
// }
